var SentryWrapper = (function SentryWrapper() {

    // Config.getReleaseVersion() arrives asynchronously
    // over AJAX (see below), while SentrySDK.init() is synchronous, so the
    // release can't be passed as an init() option the way Raven.setRelease()
    // used to be called after the fact. Captured here and applied per-event
    // in beforeSend instead: events captured before the AJAX call resolves
    // simply carry no release (matching the old code's own observable
    // behaviour), and every event captured after it resolves carries the
    // correct one.
    var releaseVersion;

    function init(user) {
        var userId = user && user.id ? user.id : 'N/A';

        if (Config && Config.sentryUrl){
            SentrySDK.init({
                dsn: Config.sentryUrl,
                environment: Config.environment,
                denyUrls: [/^chrome-extension:\/\//],
                autoSessionTracking: false,
                beforeSend: function (event) {
                    if (isMobileDevice()) {
                        return null;
                    }
                    if (releaseVersion) {
                        event.release = releaseVersion;
                    }
                    return event;
                }
            });
            Config.getReleaseVersion().then(function (version) {
                releaseVersion = version;
            });
        }

        // The pre-migration Raven code read `if (!Raven.isSetup())` here,
        // which only set user context when the client was NOT initialized
        // -- user context on an uninitialized client has no effect, so that
        // was inverted. Fixed here: set it once the client actually is
        // initialized.
        if (SentrySDK.isInitialized()) {
            SentrySDK.setUser({
                id: userId
            });
        }
    }

    function reportError(message, extra) {
        if (isMobileDevice()) {
            return;
        }
        var body = {
            level: 'warning',
            tags: {
                logger: 'humanity-app'
            }
        };

        if (extra && typeof extra === 'object') {
            body.extra = extra;
        } else if (extra && typeof extra === 'string') {
            body.extra = {
                'additionalData': extra
            };
        }
        SentrySDK.captureMessage(message, body);
    }

    function exceptionHandling(errorMessage, extra) {
        if (isMobileDevice()) {
            return;
        }
        // @sentry/browser's captureException() takes a capture
        // context (user / level / extra / tags / fingerprint / ...), which
        // has no `logger` field the way Raven's plain options object did.
        // Mapped to a `logger` tag instead -- the closest public-API
        // equivalent, still searchable/filterable in Sentry -- rather than
        // reaching into scope internals to set event.logger directly.
        var body = {
            tags: {
                logger: 'humanity-app'
            }
        };

        if (extra && typeof extra === 'object') {
            body.extra = extra;
        } else if (extra && typeof extra === 'string') {
            body.extra = {
                'additionalData': extra
            };
        }
        var error = errorMessage instanceof Error ? errorMessage : new Error(errorMessage);

        SentrySDK.captureException(error, body);
    }

    return {
        init: init,
        reportError: reportError,
        exceptionHandling: exceptionHandling
    };
})();

Object.freeze(SentryWrapper);
